import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import GatsbyImage from "gatsby-image"
import styled from "styled-components"

import responsive from "@styles/responsive"

import GithubIcon from "../icons/GithubIcon"
import InstagramIcon from "../icons/InstagramIcon"
import TwitterIcon from "../icons/TwitterIcon"
import Card from "@components/Card"

const bioQuery = graphql`
  query {
    avatar: file(relativePath: { eq: "avatar.png" }) {
      childImageSharp {
        fixed(width: 60, height: 60) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    site {
      siteMetadata {
        author
        authorBio
        social {
          twitter
          github
        }
      }
    }
  }
`

const Bio = () => {
  const result = useStaticQuery(bioQuery)
  const { author, authorBio, social } = result.site.siteMetadata
  const avatar = result.avatar.childImageSharp.fixed

  return (
    <Card>
      <BioHeading>About</BioHeading>
      <BioHeader>
        <Avatar fixed={avatar} alt={author} />
        <BioName>
          <a href={social.twitter} target="_blank" rel="noopener noreferrer">
            {author}
          </a>
        </BioName>
      </BioHeader>
      <BioMain>
        <BioText>{authorBio}</BioText>
        <BioLinks>
          <BioLink
            href={social.github}
            target="_blank"
            rel="noopener noreferrer"
          >
            <GithubIcon />
          </BioLink>
          <BioLink
            className="bio-link--email"
            href={social.twitter}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TwitterIcon />
          </BioLink>
          <BioLink
            href={social.instagram}
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon />
          </BioLink>
        </BioLinks>
      </BioMain>
    </Card>
  )
}

export default Bio

const Avatar = styled(GatsbyImage)`
  display: block;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
`

const BioMain = styled.div`
  font-size: 1.6rem;
  margin-top: 1em;
`

const BioHeading = styled.h4`
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  color: ${props => props.theme.colors.title};
  font-family: "Avenir Next W01";
  font-weight: 600;
  font-size: 2rem;
  padding-bottom: 1rem;
  margin-bottom: 2rem;

  ${responsive.sm} {
    font-size: 1.6rem;
  }
`

const BioHeader = styled.div`
  font-size: 1.6rem;
  display: flex;
  align-items: center;
`

const BioName = styled.div`
  color: ${props => props.theme.colors.title};
  font-size: 1.8rem;
  font-weight: 500;
  letter-spacing: 1px;
  margin-left: 1.6rem;

  ${responsive.sm} {
    font-size: 1.6rem;
  }
`

const BioText = styled.p`
  font-size: 1.6rem;

  ${responsive.sm} {
    font-size: 1.4rem;
  }
`

const BioLinks = styled.div`
  margin-top: 1.5em;
  display: flex;
  text-align: center;
  max-width: 244px;
`

const BioLink = styled.a`
  display: block;
  margin-right: 4rem;
  ${props => props.theme.mixins.transition};

  svg {
    display: block;
    margin: 0 auto;
    width: 2rem;
    height: 2rem;
    ${props => props.theme.mixins.transition};
  }

  &:hover svg {
    fill: ${props => props.theme.colors.title};
  }
`
